module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/download_qrcode.1a663.png";